import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { ClientsList } from "../api/api";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import _ from "lodash";
import { Button } from "../components/Button/Button";
import { useNavigate } from "react-router-dom";
import { UserdropDown } from "../components/userDropdown";

const ClientSelection = () => {
  const [clientsList, setClientsList] = useState([]);
  const [selected, setSelected] = useState<any>([]);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    ClientsList(Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setClientsList(response);
      });
  }, []);

  const uniqueOptionsList = _.uniqBy(clientsList, "clientName");
  var optionsList: any = uniqueOptionsList?.map((e: any) => ({
    label: e.clientName,
    value: e.clientID, // replace 'id' with the appropriate property name from your testData array
  }));

  const getRandomColor = () => {
    const colors = ["#2a9ef4", "#fe6e00"];
    return colors[Math.floor(Math.random() * colors.length)];
  };
  console.log(clientsList);

  const handleChange = (option: any) => {
    setSelected(option);
  };
  console.log(clientsList);
  function handlebtnClick() {
    setIsBtnLoading(true);
    return navigate("/portal/default");
  }
console.log(selected.value)
const clientInfo = _.filter(clientsList, { clientID: selected.value })
Cookies.set("client", `${selected.value}`)


  function onClick(e: any) {
    Cookies.remove("newJwt",  { path: "/" });
    Cookies.remove("client");
    Cookies.remove("roles");
    navigate("/");
  }
  return (
    <>
      <span className="float-end p-4 cursor-pointer" onClick={onClick}>
        <i className="align-middle me-1 fas fa-fw fa-arrow-alt-circle-right"></i>{" "}
        Sign out
      </span>
      <div className="SelectPopover">
        <h5>Select Client</h5>

        <div className="row my-2">
          <Select
            value={selected}
            onChange={handleChange}
            options={optionsList}
            isSearchable={true}
            placeholder="Search for an Client..."
          />
        </div>
        <div className="row my-4">
          {clientInfo?.map((e: any) => {
            return (
              <>
                <p style={{ color: "#a6a9c1" }} className="mb-2">
                  Client Info
                </p>
                <div key={e.client} className="d-flex">
                  <div className="col-1">
                    <div
                      className="rounded-circle text-center position-relative"
                      style={{
                        backgroundColor: getRandomColor(),
                        width: "50px",
                        height: "50px",
                      }}
                    >
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "2rem",
                          color: "#fff",
                          lineHeight: "50px",
                        }}
                      >
                        {e.clientName.charAt(0)}
                      </h5>
                      <span
                        className="status"
                        style={{
                          backgroundColor:
                            e.isActive === "Y" ? "#43d37d" : "#ababad",
                        }}
                      ></span>
                    </div>
                  </div>
                  <div className="col-10 mx-2 ">
                    <div className="row pt-1">
                      <div className="col-12 py-2 mx-2 lh-1">
                        <p className="m-0">{e.clientName}</p>
                        <small style={{ color: "#a6a9c1" }}>
                          {e.contactName}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
        <div className="col-12">
          <Button
            type="submit"
            className="btn-primary float-end"
            size="btn-xs"
            children="Done"
            showLoading={isBtnLoading}
            onClick={handlebtnClick}
            disabled={selected?.length === 0 ? true : false}
          />
        </div>
      </div>
    </>
  );
};

export { ClientSelection };
